module.exports = __webpack_public_path__ + "static/media/badLight.881bf3ee.svg";